import { http } from './config'

export default {
    getAtivas: () => {
        return http.get('orcamento/filiais')
    }
}
